import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { pollActionVariables } from 'src/ui/theme/buttonStyles'

export const pollHeroActionSx = {
  minHeight: 44,
  borderRadius: '18px',
  px: { xs: 1.5, sm: 2.25 },
  fontSize: { xs: 14, sm: 16 },
  fontWeight: 800,
  color: '#944217',
  borderColor: '#e8cdb2',
  background: '#fffaf5',
  '& .MuiTypography-root': {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
  },
  '&:hover': { background: '#fffaf5', borderColor: '#e8cdb2' },
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': { background: '#fff3e6', borderColor: '#d4a27a' },
  },
}

// Poll controls keep the same interaction language, with the orange brand accent.
const PollDesign = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ active = true }) =>
  active
    ? {
        ...pollActionVariables,
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            borderColor: '#e98549',
          },
        '& .MuiInputLabel-root.Mui-focused': { color: '#944217' },
      }
    : {},
)
export default PollDesign
